import { Row, Col, Input, Button, Spin } from "antd";
import Layout from "antd/lib/layout/layout";
import "../Login/Login.scss";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LoadingOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const antIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;

var md5 = require("md5");
var axios = require("axios");
var Buffer = require("buffer/").Buffer;

type LoginProps = {
  isAuth: boolean;
};

const Login = (props: LoginProps) => {
  const history = useHistory();
  const [loginFormValues, setLoginFormValues] = useState({
    email: "",
    password: "",
  });
  const [emailError, setemailError] = useState("");
  const [passwordError, setpasswordError] = useState("");
  const [isAuthentiated, setisAuthentiated] = useState("");
  const [spinner, setSpinner] = useState(false);

  const handleChange =
    (name: string) => (event: { target: { value: any } }) => {
      setemailError("");
      setpasswordError("");
      setisAuthentiated("");
      setLoginFormValues({ ...loginFormValues, [name]: event.target.value });
    };

  useEffect(() => {
    localStorage.clear();
    localStorage.setItem('region', 'apac2')
  }, [emailError, passwordError]);

  const onSubmit = () => {
    var data = JSON.stringify(loginFormValues);
    let sttarterappkey = process.env.REACT_APP_STTARTER_KEY;
    if (loginFormValues.email !== "" && loginFormValues.password !== "") {
      setSpinner(true);
      var actualString =
        loginFormValues.email + ":" + md5(loginFormValues.password);
      var base64Encode = Buffer.from(actualString, "utf8").toString("base64");

      localStorage.setItem("BASIC_TOKEN", base64Encode);
      var config = {
        method: "get",
        url: `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}organization/get.json` ,
        headers: {
          Authorization: "Basic " + base64Encode,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response: any) => {
          if (response.status === 200) {
            const Org_ID = response.data.response.organization.id;
            localStorage.setItem("ORG_ID", Org_ID);
            setSpinner(false);
            history.push("/search");
          } else if (response.status === 401) {
            setSpinner(false);
            setisAuthentiated("Please enter valid User Name or Password");
          }
        })
        .catch(function (error: any) {
          setSpinner(false);
          setisAuthentiated("Please enter valid User Name or Password");
        });

      getCountries(sttarterappkey)
    } else if (
      loginFormValues.email === "" &&
      loginFormValues.password === ""
    ) {
      setSpinner(false);
      setemailError("Please Enter a user name");
    } else if (loginFormValues.email === "") {
      setSpinner(false);
      setemailError("Please Enter a user name");
    } else {
      setSpinner(false);
      setpasswordError("Please Enter the Password");
    }
  };

  const getCountries = (sttarterappkey: any) => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_STTARTER_URL + sttarterappkey + "/countries ",

    };
    axios(config)
      .then((response: any) => {
        let countries = response.data.data
        localStorage.setItem("COUNTRY_LIST", JSON.stringify(countries));
      })
      .catch(function (error: any) {

      });

  }


  const handleKeypress = (event: any) => {
    if (event.key === "Enter") {
      onSubmit();
    }
  };

  
  return (
    <>
      <div className="loginContainer">
        <Layout style={{ height: "100vh" }}>
          <Row style={{ height: "100vh", marginRight: "0px" }}>
            <Col span={18}>
              <div className="formContainer">
                <p className="title">Sign in</p>
                <p className="subTitle">Customer Care Login</p>
                <br />
                <form>
                  <div className="formInput">
                    <label>Username</label>
                    <Input
                      value={loginFormValues.email}
                      onChange={handleChange("email")}
                      placeholder="Enter the user name"
                      name="email"
                      onKeyPress={handleKeypress}
                    />
                  </div>
                  {emailError ? (
                    <div>
                      <p className="errorText">Please Enter the Username</p>
                    </div>
                  ) : null}

                  <div className="formInput2">
                    <label>Password</label>
                    <Input.Password
                      value={loginFormValues.password}
                      onChange={handleChange("password")}
                      placeholder="Enter password"
                      name="password"
                      onKeyPress={handleKeypress}
                      iconRender={(visible) =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                    />
                  </div>
                  {passwordError ? (
                    <div>
                      <p className="errorText">Please Enter the Password</p>
                    </div>
                  ) : isAuthentiated !== "" ? (
                    <div>
                      <p className="errorText">{isAuthentiated}</p>
                    </div>
                  ) : null}
                  <Button
                    className="submitButton"
                    type="primary"
                    onClick={onSubmit}
                  >
                    Sign in
                  </Button>
                  {spinner && <Spin indicator={antIcon} />}
                </form>
              </div>
            </Col>

            <Col
              span={6}
              style={{
                height: "100vh",
              }}
            >
              <p className="headline">
                Welcome to <span> Jotun!</span>
              </p>
              <p className="footerText">
                Jotun - <span>Admin</span>
              </p>
            </Col>
          </Row>
        </Layout>
      </div>
    </>
  );
};

export default Login;
